import { trpc } from "@/data-loaders";

export const useCurrentUserEnrolments = () => {
  return trpc.getCurrentUserEnrolments.useQuery(undefined, {
    retry: false,
    gcTime: 1000 * 60 * 60 * 8, // cache for 8 hours
    staleTime: 1000 * 60 * 60 * 8, // don't consider the data stale until 8 hours
  });
};
